import 'url-search-params-polyfill';

export function getAuthVars() {
  const params = new URLSearchParams(location.search);
  if (params.get('idToken')) {
    return {
      idToken: params.get('idToken'),
    };
  }
  return null;
}

export function getErrorVar() {
  const params = new URLSearchParams(location.search);
  if (params.get('error')) {
    return params.get('error');
  }
  return null;
}
